import { PersonaRequestBody } from './PersonaRequestBody';
import { VariablesModel } from '../../../models/VariablesModel';

/**
 * @public
 */
export interface SetVariablesRequestBody extends PersonaRequestBody {
  Variables: VariablesModel;
}
